import { AcwGlobalUtility } from "@blk/acw-global-settings";
import { NotificationStatus } from "../types";
import { OperationAction } from "common/types/operationAction";
import { language } from "language/default";
export const moduleName = "notificationModule";
export const updateNotificationIconBadgeVisibility = (showBadge) => {
    const params = {
        buttonLabel: language.en.skeleton.notificationsMenu.notifications,
        isVisible: showBadge
    };
    AcwGlobalUtility.getInstance().updateGlobalUtilityPinpointBadgeVisibility(params);
};
export const updateNotificationIconBadgeFromNotifications = (notifications) => {
    if (!notifications.length) {
        updateNotificationIconBadgeVisibility(false);
        return;
    }
    const allDataSyncCompleted = notifications.every((notification) => (notification.action === OperationAction.Push || notification.action === OperationAction.Transform) &&
        notification.status === NotificationStatus.COMPLETED);
    const hasNonDataSync = notifications.some((notification) => notification.action !== OperationAction.Push && notification.action !== OperationAction.Transform);
    const showBadge = hasNonDataSync || !allDataSyncCompleted;
    updateNotificationIconBadgeVisibility(showBadge);
};
